export class ChangePassword {

  id: number;
  username: string;
  code: string;
}
